export function appearanceOf(store) {
  const a = store.appearance || {};
  return {
    headerColor: "#f9f7fc", logoWidth: 120, rotate: true,
    ...a,
    slides: a.slides?.length ? a.slides.slice(0, 5) : [{
      id: "initial", title: store.headline || "Dilo con tu estilo.", subtitle: store.tagline || "",
      kicker: "TU PRÓXIMO FAVORITO ESTÁ AQUÍ", background: "", color: "#e9dff3",
      foreground: store.banner || "/assets/campana.png", duration: 7,
    }],
    footer: { color: "#2d1d3f", textColor: "#ffffff", background: "", title: "Pequeños detalles. Grandes favoritos.",
      contactTitle: "Hablemos", linksTitle: "Más de Dilo", bottomText: "Tu estilo tiene mucho que decir.", ...a.footer },
  };
}
export function nextSku(existing, prefix = "P") {
  const used = new Set(existing.map(x => String(x.sku || x).toUpperCase()));
  let n = 1;
  while (used.has(prefix + String(n).padStart(3, "0"))) n++;
  return prefix + String(n).padStart(3, "0");
}
export function inventoryValue(products, variants) {
  const prices = new Map(products.map(p => [p.id, Number(p.price) || 0]));
  return variants.reduce((sum, v) => sum + Math.max(0, Number(v.stock) || 0) * (prices.get(v.product_id) || 0), 0);
}
